var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0b6f68a204f8bba6183f8a32f04575636a4e8dae"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["enterprise-web@whoop"]={id:"0b6f68a204f8bba6183f8a32f04575636a4e8dae"};
      